export const HelpLink = 'https://t.me/openway_support_bot';
export const SupportEmail = 'openwayvpn@gmail.com';
// Основной Telegram-бот (TG_BOT_LINK в .env, фронту доступен как REACT_APP_TG_BOT_LINK) —
// используется для прямых ссылок «перейти в Telegram» на FAQ.
export const TelegramBotLink = process.env.REACT_APP_TG_BOT_LINK || 'https://t.me/OpenWayVPN_bot';